import { useContext } from 'react'
import ProductFruitsContext, {
  ProductFruitsContextValue,
} from '../Components/ProductFruits/Context'

const useProductFruitsContext = (): ProductFruitsContextValue => {
  const context = useContext(ProductFruitsContext)

  if (context === undefined) {
    throw new Error(
      'useProductFruitsContext() must be used within ProductFruitsProvider'
    )
  }

  return context
}

export default useProductFruitsContext
